function getCompleteLang(lang) {
  if (!lang) {
    return "zh-CN";
  }
  if (lang.toLowerCase() === "cn") {
    return "zh-CN";
  }
  if (/^[a-z]{2}-[A-Z]{2}$/.test(lang)) {
    return lang;
  } else if (/^[a-zA-Z]{2}-[a-zA-Z]{2}$/.test(lang)) {
    const [languageCode, countryCode] = lang.split("-");
    return `${languageCode.toLowerCase()}-${countryCode.toUpperCase()}`;
  } else {
    if (lang.toLowerCase() === "en") {
      return "en-US";
    }
    if (lang.toLowerCase() === "zh") {
      return "zh-CN";
    }
    console.error(`url\u4E0A\u8BED\u8A00\u53C2\u6570\u683C\u5F0F\u9519\u8BEF${lang}\uFF0C\u5E94\u8BE5\u4E3A\u5E26-\u7684\u8BED\u8A00\u6807\u8BC6\uFF0C\u5982en-US\u3001zh-CN`);
    return "zh-CN";
  }
}
export { getCompleteLang };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getCompleteLang.js